module.exports = __webpack_public_path__ + "img/slash-forward.b5522751.svg";